var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 412.03 113.16",
    width: 140,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#008244",
    fillRule: "evenodd",
    points: "266.27 50.66 275.16 39.69 292.89 17.94 276.08 17.94 259.87 39.69 254.2 47.31 254.2 39.69 254.2 17.94 240.37 17.94 240.37 39.69 240.37 53.64 240.37 88.31 254.2 88.31 254.2 56.99 276.81 88.31 294.78 88.31 268.52 53.64 266.27 50.66"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008244",
    fillRule: "evenodd",
    d: "M149.1,17.94h-19.25V88.31h19.25c33.02,.12,34.42-30.34,34.49-34.73v-.43c0-.85,0-6.7-2.25-13.46-3.35-9.93-11.64-21.75-32.23-21.75Zm20.17,35.76c-.3,26.2-25.35,22.66-25.35,22.66V30s15.48-2.19,22.24,9.63c1.89,3.29,3.11,7.68,3.11,13.53v.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008244",
    fillRule: "evenodd",
    d: "M388.05,24.37c-4.12-10.9-11.4-10.57-15.5,0-4.2,10.83-22.1,58.3-24.04,63.47l-19.49-28.9s5-.97,9.08-5.24c2.68-2.92,5-7.31,5-14.01v-.06s1.71-21.69-22.6-21.69h-19.31V88.31h13.83v-28.27l17.24,28.27h29.89l5.33-14.77h24.7l5.81,14.77h14.05s-19.86-53.04-23.98-63.93Zm-69.75,25.86h-3.29V29.21h3.29c11.88-.06,11.39,10.3,11.39,10.3v.18c0,1.34-.66,10.54-11.39,10.54Zm53.04,11.92l8.96-25.43,8.72,25.43h-17.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#008244",
    fillRule: "evenodd",
    points: "192.18 39.69 192.12 53.64 192.12 88.31 228.43 88.31 228.43 76.37 206.01 76.37 206.01 57.36 227.7 57.36 227.7 53.64 227.7 45.36 206.01 45.36 206.01 39.69 206.01 30 228.49 30 228.49 18 192.18 18 192.18 39.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008244",
    fillRule: "evenodd",
    d: "M79.11,33.41C64.93,24.96,28.09,3.7,23.57,1.11,19.05-1.47,15.18,.47,15.18,6.6v63.29l17.76-9.69V27.27l38.75,22.93L0,92.5v20.67s65.23-37.78,79.11-45.53c13.89-7.75,15.18-25.19,0-34.23Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logo-footer.60d0d367cfc6ec52a7c1a5c188db3009.svg";
export { ForwardRef as ReactComponent };